import { each } from 'lodash';

export class AbsentStudentsListExporter {
  static $inject = ['FileSaver', 'Blob'];

  constructor(private FileSaver, private Blob) {}

  // Methods
  createAbsentListCsv = absentStudentList => {
    const header = ['Student ID', 'Last Name', 'First Name', 'Support', 'Attendance', 'Event Date'];
    let csvRows = header + '\n';
    each(absentStudentList, (row: any) => {
      let name = row.student.split(',');
      csvRows += [row.studentIdTrimmed, name[0], name[1], row.support, row.attendanceStatus, row.eventDate] + '\n';
    });
    return csvRows;
  };

  exportCsv = (csvString, fileName, docType) => {
    const file_name = fileName;
    const blob = new this.Blob([csvString], {
      type: docType,
    });
    this.FileSaver.saveAs(blob, file_name);
  };
}

angular.module('nv.SupportsModule').service('AbsentStudentsListExporter', AbsentStudentsListExporter);
